import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=1ed1008c&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=js&"
export * from "./tinymce.vue?vue&type=script&lang=js&"
import style0 from "./tinymce.vue?vue&type=style&index=0&id=1ed1008c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1008c",
  null
  
)

export default component.exports